module.exports = __webpack_public_path__ + "img/Stylus Stanton C.af409293.png";